module.exports = __webpack_public_path__ + "static/media/read2.95f113ab.svg";